import React, { useContext, createRef, useRef } from 'react';
import LocaleContext from 'constants/localization';
import { Editor } from '@tinymce/tinymce-react';

export default function RichTextEdit({value, index, onChange, ref}) {
  const LS = useContext(LocaleContext);
  const editorRef = useRef(ref);
  
  const handleInputChange = (val,editor) => {
	onChange({ 
        target: { value: val, getAttribute: () => index }
     });
  };

  return (
    <React.Fragment>
      <Editor
        onInit={(evt, editor) => editorRef.current = editor}
        value={value}
        onEditorChange={handleInputChange}
        tinymceScriptSrc="js/tinymce/tinymce.min.js"
        init={{
        height: 400,
        entity_encoding : "raw",
        menubar: false, 
		branding: false,
		elementpath: false,
		statusbar: false,
		formats: {
	        bold : {inline : 'b' },  
	        italic : {inline : 'i' },
	        underline : {inline : 'u'},
	        strikethrough : {inline : 'del'}
	    },
	    valid_elements : "b,i,u,del,p[class]",
	    extended_valid_elements: "b,i",
        plugins: [
           'autolink','lists','link','charmap','preview','anchor','searchreplace','visualblocks','fullscreen','insertdatetime','wordcount'
        ],
        toolbar: 'undo redo | bold italic underline strikethrough | ',
        content_style: 'body { font-family:"Open sans",sans-serif; font-size:1em }'
        }}
      />
    </React.Fragment>
  );
}
